import { render, staticRenderFns } from "./Info-model.vue?vue&type=template&id=7d658ef1&"
import script from "./Info-model.vue?vue&type=script&lang=js&"
export * from "./Info-model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports